<template>
    <b-modal title="Project"  no-close-on-backdrop hide-footer size="lg" v-model="largeModal"  @ok="largeModal = false">
        <form>
            <div class="form-group row">
                <div class="col-sm-5">
                    <p><b>Name:</b> {{project.name}}</p>
                </div>
                <div class="col-sm-5">
                    <p><b>Category:</b> {{project.category}}</p>
                </div>
                <div class="col-sm-5">
                    <p><b>Daya Type:</b> {{project.diameter}}</p>
                </div>
                <div class="col-sm-5">
                    <p><b>Status:</b> {{project.status}}</p>
                </div>
                <div class="col-sm-5">
                    <p><b>Price:</b> {{project.price}}</p>
                </div>
                <div class="col-sm-5">
                    <p><b>Created By:</b> {{project.created_by}}</p>
                </div>
                <div class="col-sm-5">
                    <p><b>Updated By:</b> {{project.updated_by}}</p>
                </div>
                <div class="col-sm-5">
                     <p><b>Created At:</b> {{project.created_at.date}}</p>
                </div>
                <div class="col-sm-5">
                     <p><b>Updated At:</b> {{project.updated_at.date}}</p>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
export default {
    data(){
        return{
            largeModal:false,
            project:''
        }
    },
    methods:{
        openModal(project){
            this.largeModal = true
            this.project = project
            //console.log(this.project)
        }
    }
}
</script>

<style>

</style>
